<template>
<v-container max-width="100%" fluid>
    <CRUDEquipamentos />
</v-container>
</template>

<script>
// @ is an alias to /src
import CRUDEquipamentos from '@/components/CRUDEquipamentos.vue'

export default {
  name: 'Equipamentos',
  components: {
    CRUDEquipamentos
  }
}
</script>